import React from 'react'

import { useCookies } from 'react-cookie'

import { useQuery } from '@tanstack/react-query'

import isEmpty from 'lodash/isEmpty'

import type {
  AuthContextData,
  ProviderProps,
  UserProps,
} from '../helpers/types/context/auth.types'

import { axios } from '../services/axios'

export const AuthContext = React.createContext<AuthContextData>(
  {} as AuthContextData
)

let authChannel = new BroadcastChannel('parkoff.auth')

export function AuthProvider({ children }: ProviderProps) {
  const [cookies, setCookies] = useCookies(['parkoff.token'])

  const { data } = useQuery(
    ['token'],
    async () => {
      try {
        const response = await axios().get<UserProps>('/auth')

        return response.data
      } catch (err) {
        destroyToken()
      }
    },
    {
      enabled: !isEmpty(cookies['parkoff.token']),
    }
  )

  const token = cookies['parkoff.token']

  React.useEffect(() => {
    authChannel = new BroadcastChannel('parkoff.auth')

    authChannel.onmessage = (message: MessageEvent) => {
      if (message.data === 'signOut') {
        destroyToken()
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function setToken(newToken: string) {
    setCookies('parkoff.token', newToken, {
      maxAge: 60 * 30,
      path: '/',
    })
  }

  function destroyToken() {
    setCookies('parkoff.token', '', { maxAge: -1 })

    authChannel.postMessage('signOut')
  }

  return (
    <AuthContext.Provider value={{ setToken, destroyToken, token, user: data }}>
      {children}
    </AuthContext.Provider>
  )
}
